import ApiResponse from "../models/ApiResponse";
import TestInfoResponse from "../models/test-series/TestInfoResponse";
import Api from "./Api";

class TestInformationApi {
  constructor(private api: Api) {}

  public fetchTestInformation(requestId: string): ApiResponse<TestInfoResponse> {
    return this.api.get(`/test-request/v2/testrequests/${requestId}/test-info`);
  }
}

export default TestInformationApi;
